export default __webpack_public_path__ + "static/media/company_r.c7c95193.jpg";